import SortableTable from "@/Components/SortableTable";
import { usePage } from "@inertiajs/inertia-react";
import React from "react";
import {
  convertToHumanReadable,
  convertWeightToHumanReadable,
} from "@/Utilities/Utilities";

const formatAnswerResult = (str, col) => {
  if (!isNaN(str)) {
    return convertToHumanReadable(str);
  }

  if (!str.includes("\r")) {
    return str;
  }

  // Wrap the first line in bold
  const lines = str.split("\r");

  // Sort the lines by the largest number where found in string
  const floatRegex = /(\d+(?:\.\d+)?)/;
  lines.sort((a, b) => {
    const aFloat = parseFloat(a.match(floatRegex)[1]);
    const bFloat = parseFloat(b.match(floatRegex)[1]);
    return bFloat - aFloat;
  });

  // lines[0] = `<span class="font-bold">${lines[0]}asd</span>`;
  return lines.join("</br>");
};

const TeamsReportedDataTable = ({ teamsAnswers, question }) => {
  const teams = usePage().props?.teams?.data || [];

  const teamsWithoutData = teams.filter(
    (team) =>
      Object.keys(teamsAnswers).indexOf(team.id.toString()) === -1 &&
      team.questions.find((q) => q.id === question.id),
  );

  const hasEmission =
    question.inputs?.[0]?.emission_factor_id !== null || false;

  const units = question.inputs.map((input) => input.unit);
  const uniqueUnits = [...new Set(units)];
  const unitString = uniqueUnits.join(", ");

  const columns = [
    { key: "team", label: "Team" },
    {
      key: "answer",
      label: unitString ? `Alternative (${unitString})` : "Alternative",
    },
  ];

  if (hasEmission) {
    columns.push({ key: "emission", label: "Emission" });
  }

  const data = Object.keys(teamsAnswers)
    .map((team_id) => {
      const team = teams.find((team) => team.id === Number(team_id));
      const answers = teamsAnswers[team_id].readable_answer;

      return {
        team: team.name,
        answer: answers ? answers.answer : "-",
        emission: hasEmission
          ? answers
            ? convertWeightToHumanReadable(parseFloat(answers.total)).concat +
              "&nbsp;CO₂e"
            : "-"
          : undefined,
        link: `/teams/${team.id}`,
      };
    })
    .concat(
      teamsWithoutData.map((team) => ({
        team: team.name,
        answer: "-",
        emission: hasEmission ? "-" : undefined,
        link: `/teams/${team.id}`,
      })),
    );

  return (
    <SortableTable
      columns={columns}
      data={data}
      className="-mt-4"
      externalValueModifier={formatAnswerResult}
    />
  );
};

export default TeamsReportedDataTable;
